// The one switch every debug surface hangs off.
//
// The live stage, the planning stage, the debrief and the language-model cache each publish a handle on
// `window` for the end-to-end tests and for poking at a run from the console, and `?proof` opens the
// checkpoint-1 map harness. All of that shipped in the deployed build, where it is a console API onto
// the simulation that nobody asked for.
//
// It is now behind this flag: on in development, and on in any build when the page is opened with
// `?debug`, which is how the Playwright specs get their handles back. Nothing else changes - the
// handles are exactly the same objects they always were.

/** True in the dev server, or when the page was opened with `?debug`. */
export const DEBUG: boolean = (() => {
  if (import.meta.env?.DEV) return true;
  if (typeof location === 'undefined') return false;
  try {
    return new URLSearchParams(location.search).has('debug');
  } catch {
    return false;
  }
})();
